import {html, LitElement, type TemplateResult} from "lit";
import {customElement, property} from "lit/decorators.js";
import Styles from "./legend.lit.scss";
import {pinIcon} from "./pinIcon";
import {COLOR_PRIMARY, getComputedColor, MARKER_COLOR_PROPS} from "./colors";

@customElement("eop-google-maps-legend-item")
export class EopGoogleMapsLegendItem extends LitElement {

    public static readonly styles = Styles;

    @property({attribute: "color"})
    public color: string;

    @property({attribute: "label"})
    public label: string;

    public render(): TemplateResult {
        return html`
            <div class="legend-item">
                <span class="icon">${this.markerIcon()}</span>
                <span class="label">${this.label}</span>
            </div>
        `;
    }

    private markerIcon(): HTMLElement {
        const icon = pinIcon({width: 25, height: 28, scale: 1.1});
        icon.style.color = getComputedColor(this, MARKER_COLOR_PROPS[this.color] ?? COLOR_PRIMARY);
        return icon;
    }
}